import algoliasearch from 'algoliasearch';

export const createSearchClient = ({ appId, apiKey }) => {
  const client = algoliasearch(appId, apiKey, {
    _useRequestCache: true,
  });
  // if we need to transform queries, intercept here
  return client;
};
